module.exports = __webpack_public_path__ + "static/media/section1-icon4.a5118f81.png";